export const tipRecordTableOption = {
    page:false,
    border: true,
    stripe: true,
    align:'center',
    menu: false,
    menuAlign: 'center',
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    searchShow: false,
    searchBtn: false,
    column: [
    {
      label: 'ID',
      prop: 'id',
      align: 'center',
      width: 80,
    },{
      label: '打赏目标',
      prop: 'targetId',
      solt: true,
      align: 'center',
      width: 80,
    },{
      label: '目标类型',
      prop: 'targetType',
      overHidden: true,
      solt: true,
      align: 'center',
      width: 120,
    },{
      label: '被打赏人ID',
      prop: 'targetMemberId',
      hide: true,
      align: 'center',
      width: 120,
    },{
      label: '被打赏人昵称',
      prop: 'targetMemberName',
      overHidden: true,
      solt: true,
      align: 'center',
      width: 120
    },{
      label: '打赏人ID',
      prop: 'tipper',
      hide: true,
      align: 'center',
      width: 120,
    },{
      label: '打赏人昵称',
      prop: 'tipperName',
      overHidden: true,
      solt: true,
      align: 'center',
      width: 120
    },{
      label: '打赏类型',
      prop: 'tipType',
      overHidden: true,
      solt: true,
      align: 'center',
      width: 120,
    },{
      label: '打赏数值',
      prop: 'tipValue',
      align: 'center',
      width: 120,
    },{
      label: '打赏时间',
      prop: 'insertedTime',
      sortable: true,
      align: 'center',
      width: 160,
    }]
  }
  
  export const tipTypeOptions = [
    { label: '积分打赏', value: 1 },
  ]

  export const targetTypeOptions = [
    { label: '打赏帖子', value: 1 },
  ]